import { Fragment, useEffect, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon, XIcon } from '@heroicons/react/outline'
import { classNames } from '../helpers/utils'

export default function ComboInput({
    options = [],
    onSelect,
    defaultSelected,
}) {
    const [selected, setSelected] = useState(defaultSelected || null)

    useEffect(() => {
        setSelected(defaultSelected || null)
    }, [defaultSelected])

    useEffect(() => {
        onSelect(selected)
    }, [selected, onSelect])

    return (
        <Listbox value={selected} onChange={setSelected}>
            {({ open }) => (
                <div className="relative">
                    <Listbox.Button className="relative block w-full rounded-[8px] border border-[#E1DACE] bg-white px-[14px] py-[11px] pr-10 text-left text-[13px] text-[#1A1D23] transition-all duration-150 focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15">
                        <span
                            className={classNames(
                                selected
                                    ? 'font-medium text-[#1A1D23]'
                                    : 'text-gray-400',
                                'block truncate',
                            )}>
                            {selected || 'Select column'}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
                            <SelectorIcon
                                className="h-4 w-4"
                                aria-hidden="true"
                            />
                        </span>
                    </Listbox.Button>

                    {selected && (
                        <button
                            type="button"
                            onClick={(event) => {
                                event.stopPropagation()
                                setSelected(null)
                            }}
                            className="absolute inset-y-0 right-8 z-10 flex items-center text-gray-400 hover:text-gray-600">
                            <XIcon className="h-4 w-4" aria-hidden="true" />
                        </button>
                    )}

                    <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <Listbox.Options className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-[10px] border border-[#E1DACE] bg-white py-1 text-[13px] shadow-[0_18px_40px_rgba(0,0,0,0.18),0_2px_6px_rgba(0,0,0,0.08)] focus:outline-none">
                            {options.map((option) => (
                                <Listbox.Option
                                    key={option}
                                    value={option}
                                    className={({ active }) =>
                                        classNames(
                                            active
                                                ? 'bg-[#FDF4EC] text-[#1A1D23]'
                                                : 'text-[#1A1D23]',
                                            'relative cursor-default select-none py-[11px] pl-[14px] pr-9',
                                        )
                                    }>
                                    {({ selected: isSelected }) => (
                                        <>
                                            <span
                                                className={classNames(
                                                    'block truncate',
                                                    isSelected
                                                        ? 'font-semibold'
                                                        : 'font-normal',
                                                )}>
                                                {option}
                                            </span>

                                            {isSelected ? (
                                                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-[#ED5C2F]">
                                                    <CheckIcon
                                                        className="h-4 w-4"
                                                        aria-hidden="true"
                                                    />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            )}
        </Listbox>
    )
}
